import { Component, OnInit } from '@angular/core';
import { SidebarNavComponent } from '../sidebar-nav/sidebar-nav.component';
import { CommunicationService } from 'src/app/shared/services/communication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  isSideBarMinimized = false;

  constructor(
    private communicationService: CommunicationService
  ) { }

  ngOnInit() {}

  minimizeSideBar() {
    this.isSideBarMinimized = !this.isSideBarMinimized;
    this.communicationService.sendSideBarStatus(this.isSideBarMinimized);
  }

}
